import Breadcrumb from '@/components/feature/Breadcrumb';
import { aboutInfo, siteInfo } from '@/mocks/siteData';

export default function AboutPage() {
  return (
    <div className="pt-16">
      <div className="bg-background-100 border-b border-background-200">
        <div className="max-w-4xl mx-auto">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '关于我们' },
            ]}
          />
        </div>
      </div>

      <section className="py-12 md:py-16 bg-background-50">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <div className="text-center mb-12">
            <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mx-auto mb-5">
              <i className="ri-drop-fill text-2xl"></i>
            </div>
            <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
              关于 {aboutInfo.brandName}
            </h1>
            <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
              {aboutInfo.tagline}
            </p>
          </div>

          <div className="bg-background-50 border border-background-200 rounded-lg p-6 md:p-8 mb-8">
            <h2 className="text-xl font-heading font-semibold text-foreground-950 mb-4">品牌介绍</h2>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              {aboutInfo.introduction}
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              {aboutInfo.mission}
            </p>
          </div>

          <div className="bg-background-50 border border-background-200 rounded-lg p-6 md:p-8 mb-8">
            <h2 className="text-xl font-heading font-semibold text-foreground-950 mb-4">发展历程</h2>
            <div className="relative pl-6 border-l-2 border-accent-200">
              <div className="mb-6 relative">
                <div className="absolute -left-[25px] w-3 h-3 rounded-full bg-accent-500"></div>
                <span className="text-xs text-accent-600 font-medium mb-1 block">2024 年初</span>
                <h3 className="text-base font-heading font-semibold text-foreground-900 mb-1">平台创立</h3>
                <p className="text-sm text-foreground-600">
                  从个人经验分享博客起步，致力于传播科学的憋尿知识。
                </p>
              </div>
              <div className="mb-6 relative">
                <div className="absolute -left-[25px] w-3 h-3 rounded-full bg-accent-500"></div>
                <span className="text-xs text-accent-600 font-medium mb-1 block">2024 年底</span>
                <h3 className="text-base font-heading font-semibold text-foreground-900 mb-1">内容体系化</h3>
                <p className="text-sm text-foreground-600">
                  建立了六大分类体系，超过50篇深度原创文章，服务数万读者。
                </p>
              </div>
              <div className="relative">
                <div className="absolute -left-[25px] w-3 h-3 rounded-full bg-accent-500"></div>
                <span className="text-xs text-accent-600 font-medium mb-1 block">2025-2026</span>
                <h3 className="text-base font-heading font-semibold text-foreground-900 mb-1">持续发展</h3>
                <p className="text-sm text-foreground-600">
                  持续优化内容质量，拓展科普范围，服务超过50万挑战爱好者。
                </p>
              </div>
            </div>
          </div>

          <div className="mb-8">
            <h2 className="text-xl font-heading font-semibold text-foreground-950 mb-5">核心价值</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {aboutInfo.values.map((v, idx) => (
                <div
                  key={idx}
                  className="bg-background-50 border border-background-200 rounded-lg p-5 hover:border-accent-300 transition-all duration-200"
                >
                  <h3 className="font-heading font-semibold text-foreground-900 text-base mb-2">
                    {v.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                    {v.description}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-background-100 border border-background-200 rounded-lg p-6 md:p-8">
            <h2 className="text-xl font-heading font-semibold text-foreground-950 mb-5">联系我们</h2>
            <p className="text-sm text-foreground-600 mb-6">
              如果你有任何问题、建议或合作意向，欢迎通过以下方式联系我们。我们会在24小时内回复。
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
                  <i className="ri-mail-line"></i>
                </div>
                <div>
                  <h4 className="text-sm font-medium text-foreground-900">电子邮箱</h4>
                  <a href={`mailto:${aboutInfo.contact.email}`} className="text-sm text-accent-600 hover:text-accent-700 whitespace-nowrap">
                    {aboutInfo.contact.email}
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
                  <i className="ri-wechat-line"></i>
                </div>
                <div>
                  <h4 className="text-sm font-medium text-foreground-900">微信公众号</h4>
                  <p className="text-sm text-foreground-600">{aboutInfo.contact.wechat}</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
                  <i className="ri-weibo-line"></i>
                </div>
                <div>
                  <h4 className="text-sm font-medium text-foreground-900">微博</h4>
                  <p className="text-sm text-foreground-600">{aboutInfo.contact.weibo}</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
                  <i className="ri-map-pin-line"></i>
                </div>
                <div>
                  <h4 className="text-sm font-medium text-foreground-900">地址</h4>
                  <p className="text-sm text-foreground-600">{aboutInfo.contact.address}</p>
                </div>
              </div>
            </div>

            <form
              data-readdy-form
              action="https://readdy.ai/api/form/d9q50hknlsngrm4llrig"
              method="POST"
              className="space-y-4"
              onSubmit={(e) => {
                e.preventDefault();
                const form = e.currentTarget;
                const honeypot = (form.querySelector('[name="phone_alt"]') as HTMLInputElement);
                if (honeypot && honeypot.value.trim()) {
                  const msg = document.getElementById('contact-msg');
                  if (msg) { msg.textContent = '提交成功！我们会尽快回复您。'; msg.className = 'text-green-600 text-sm mt-3'; }
                  form.reset();
                  return;
                }
                const formData = new FormData(form);
                const url = form.getAttribute('action') || '';
                fetch(url, { method: 'POST', body: new URLSearchParams(formData as any).toString(), headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
                  .then(async (r) => {
                    const t = await r.text();
                    let parsed: any = {};
                    try { parsed = JSON.parse(t); } catch (_) { parsed = {}; }
                    const msg = document.getElementById('contact-msg');
                    if (!msg) return;
                    if (r.ok && parsed?.code === 'OK') {
                      msg.textContent = '提交成功！我们会尽快回复您。';
                      msg.className = 'text-green-600 text-sm mt-3';
                      form.reset();
                    } else {
                      const errMsg = parsed?.meta?.message || parsed?.message || '提交失败，请稍后再试。';
                      msg.textContent = errMsg;
                      msg.className = 'text-red-600 text-sm mt-3';
                    }
                  })
                  .catch(() => {
                    const msg = document.getElementById('contact-msg');
                    if (msg) { msg.textContent = '网络错误，请稍后再试。'; msg.className = 'text-red-600 text-sm mt-3'; }
                  });
              }}
            >
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-800 mb-1.5">姓名</label>
                  <input
                    id="contact-name"
                    name="name"
                    type="text"
                    required
                    className="w-full px-4 py-2.5 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:ring-1 focus:ring-accent-400 focus:border-accent-400 transition-colors"
                    placeholder="请输入姓名"
                  />
                </div>
                <div>
                  <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-800 mb-1.5">邮箱</label>
                  <input
                    id="contact-email"
                    name="email"
                    type="email"
                    required
                    className="w-full px-4 py-2.5 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:ring-1 focus:ring-accent-400 focus:border-accent-400 transition-colors"
                    placeholder="请输入邮箱"
                  />
                </div>
              </div>
              <div>
                <label htmlFor="contact-subject" className="block text-sm font-medium text-foreground-800 mb-1.5">主题</label>
                <input
                  id="contact-subject"
                  name="subject"
                  type="text"
                  required
                  className="w-full px-4 py-2.5 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:ring-1 focus:ring-accent-400 focus:border-accent-400 transition-colors"
                  placeholder="请输入主题"
                />
              </div>
              <div>
                <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-800 mb-1.5">留言内容</label>
                <textarea
                  id="contact-message"
                  name="message"
                  rows={4}
                  required
                  maxLength={500}
                  className="w-full px-4 py-2.5 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:ring-1 focus:ring-accent-400 focus:border-accent-400 transition-colors resize-none"
                  placeholder="请输入留言内容（不超过500字）"
                ></textarea>
              </div>
              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="footer-honeypot"
              />
              <button
                type="submit"
                className="px-6 py-3 rounded-md bg-accent-500 text-background-50 font-medium text-sm whitespace-nowrap hover:bg-accent-600 transition-colors cursor-pointer"
              >
                提交留言
              </button>
              <div id="contact-msg" className="text-sm mt-3"></div>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
}